// Textos da Floresta e carvão da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.flor.proposta': 'Proposta até a Segreda trazer o processo',
    'farm.flor.kpi.hectares': 'Eucalipto plantado',
    'farm.flor.kpi.prontos': 'Prontos para corte',
    'farm.flor.kpi.fornos': 'Fornos ativos',
    'farm.flor.kpi.carvao': 'Carvão em {{mes}}',
    'farm.flor.ha': '{{n}} ha',
    'farm.flor.m3': '{{n}} m³',
    'farm.flor.m3Ha': '{{n}} m³/ha',
    'farm.flor.st': '{{n}} st de lenha',
    'farm.flor.deTotal': '{{n}} de {{total}}',
    'farm.flor.cliqueNoTalhao': 'Clique num talhão para filtrar a lista',
    'farm.flor.aba.talhoes': 'Talhões',
    'farm.flor.aba.fornos': 'Fornos',
    'farm.flor.aba.producao': 'Produção',
    'farm.flor.abas': 'Partes do módulo',
    'farm.flor.fase.formacao': 'Em formação',
    'farm.flor.fase.crescimento': 'Em crescimento',
    'farm.flor.fase.pronto': 'Pronto para corte',
    'farm.flor.fase.corte': 'Em corte',
    'farm.flor.faseQtd': '{{n}} talhões',
    'farm.flor.col.talhao': 'Talhão',
    'farm.flor.col.clone': 'Clone',
    'farm.flor.col.plantio': 'Plantio',
    'farm.flor.col.ciclo': 'Ciclo de corte',
    'farm.flor.col.volume': 'Volume estimado',
    'farm.flor.col.fase': 'Fase',
    'farm.flor.rotacao': '{{n}}ª rotação',
    'farm.flor.idadeMeses': '{{n}} meses',
    'farm.flor.idadeAnos': '{{a}} anos e {{m}} meses',
    'farm.flor.idadeAnosExatos': '{{a}} anos',
    'farm.flor.cortePrevisto': 'Corte previsto em {{data}}',
    'farm.flor.percentCiclo': '{{n}}% do ciclo',
    'farm.flor.bateria': 'Bateria {{b}}',
    'farm.flor.forno': 'Forno {{n}}',
    'farm.flor.status.carbonizando': 'Carbonizando',
    'farm.flor.status.resfriando': 'Resfriando',
    'farm.flor.status.vazio': 'Vazio',
    'farm.flor.status.ativos': 'Ativos',
    'farm.flor.fornoTooltip': 'Forno {{n}}, {{status}}',
    'farm.flor.col.forno': 'Forno',
    'farm.flor.col.status': 'Status',
    'farm.flor.col.cicloForno': 'Ciclo',
    'farm.flor.col.descarga': 'Descarga',
    'farm.flor.col.carga': 'Carga do forno',
    'farm.flor.col.origem': 'Origem da lenha',
    'farm.flor.diaDoCiclo': 'Dia {{d}} de {{total}}',
    'farm.flor.acesoEm': 'Aceso em {{data}}',
    'farm.flor.aguardandoCarga': 'Aguardando carga',
    'farm.flor.grafico.titulo': 'Carvão por mês',
    'farm.flor.grafico.produzido': 'Produzido',
    'farm.flor.grafico.expedido': 'Expedido',
    'farm.flor.grafico.vazio': 'Sem produção no período',
    'farm.flor.grafico.subtitulo': 'Metros cúbicos nos últimos 12 meses',
    'farm.flor.col.cargaCarvao': 'Carga',
    'farm.flor.col.destino': 'Destino',
    'farm.flor.col.volumeCarga': 'Volume',
    'farm.flor.col.dof': 'DOF',
    'farm.flor.statusCarga.expedida': 'Expedida',
    'farm.flor.statusCarga.entregue': 'Entregue',
    'farm.flor.filtro.fase': 'Fase',
    'farm.flor.filtro.status': 'Status',
    'farm.flor.filtro.mes': 'Mês',
    'farm.flor.filtro.destino': 'Destino',
    'farm.flor.todos': 'Todos',
    'farm.flor.todas': 'Todas',
    'farm.flor.buscaTalhao': 'Buscar por talhão ou clone',
    'farm.flor.buscaCarga': 'Buscar por carga, DOF ou destino',
    'farm.flor.excel': 'Excel',
    'farm.flor.semResultado': 'Nada para mostrar com estes filtros.',
    'farm.flor.semVolume': 'Sem estimativa',
    'farm.flor.ajuda.talhoes': 'Cada talhão de eucalipto com o clone, a idade e o ciclo de corte. O volume sai do incremento médio do clone. A cor e o porte das copas no desenho acompanham a idade.',
    'farm.flor.ajuda.fornos': 'A bateria de fornos em ciclo: vazio para descarga e carga, carbonizando e resfriando até a descarga. Os chips filtram a lista.',
    'farm.flor.ajuda.producao': 'O carvão produzido e o expedido por mês, e as cargas que saem com DOF.',
  },
  en: {
    'farm.flor.proposta': 'Proposal until Segreda brings the process',
    'farm.flor.kpi.hectares': 'Eucalyptus planted',
    'farm.flor.kpi.prontos': 'Ready to cut',
    'farm.flor.kpi.fornos': 'Kilns in use',
    'farm.flor.kpi.carvao': 'Charcoal in {{mes}}',
    'farm.flor.ha': '{{n}} ha',
    'farm.flor.m3': '{{n}} m³',
    'farm.flor.m3Ha': '{{n}} m³/ha',
    'farm.flor.st': '{{n}} st of wood',
    'farm.flor.deTotal': '{{n}} of {{total}}',
    'farm.flor.cliqueNoTalhao': 'Click a stand to filter the list',
    'farm.flor.aba.talhoes': 'Stands',
    'farm.flor.aba.fornos': 'Kilns',
    'farm.flor.aba.producao': 'Production',
    'farm.flor.abas': 'Module sections',
    'farm.flor.fase.formacao': 'Establishing',
    'farm.flor.fase.crescimento': 'Growing',
    'farm.flor.fase.pronto': 'Ready to cut',
    'farm.flor.fase.corte': 'Being cut',
    'farm.flor.faseQtd': '{{n}} stands',
    'farm.flor.col.talhao': 'Stand',
    'farm.flor.col.clone': 'Clone',
    'farm.flor.col.plantio': 'Planting',
    'farm.flor.col.ciclo': 'Cutting cycle',
    'farm.flor.col.volume': 'Estimated volume',
    'farm.flor.col.fase': 'Stage',
    'farm.flor.rotacao': 'Rotation {{n}}',
    'farm.flor.idadeMeses': '{{n}} months',
    'farm.flor.idadeAnos': '{{a}} years and {{m}} months',
    'farm.flor.idadeAnosExatos': '{{a}} years',
    'farm.flor.cortePrevisto': 'Cut planned for {{data}}',
    'farm.flor.percentCiclo': '{{n}}% of the cycle',
    'farm.flor.bateria': 'Battery {{b}}',
    'farm.flor.forno': 'Kiln {{n}}',
    'farm.flor.status.carbonizando': 'Carbonizing',
    'farm.flor.status.resfriando': 'Cooling',
    'farm.flor.status.vazio': 'Empty',
    'farm.flor.status.ativos': 'In use',
    'farm.flor.fornoTooltip': 'Kiln {{n}}, {{status}}',
    'farm.flor.col.forno': 'Kiln',
    'farm.flor.col.status': 'Status',
    'farm.flor.col.cicloForno': 'Cycle',
    'farm.flor.col.descarga': 'Unloading',
    'farm.flor.col.carga': 'Kiln load',
    'farm.flor.col.origem': 'Wood source',
    'farm.flor.diaDoCiclo': 'Day {{d}} of {{total}}',
    'farm.flor.acesoEm': 'Lit on {{data}}',
    'farm.flor.aguardandoCarga': 'Waiting for load',
    'farm.flor.grafico.titulo': 'Charcoal per month',
    'farm.flor.grafico.produzido': 'Produced',
    'farm.flor.grafico.expedido': 'Shipped',
    'farm.flor.grafico.vazio': 'No production in the period',
    'farm.flor.grafico.subtitulo': 'Cubic meters in the last 12 months',
    'farm.flor.col.cargaCarvao': 'Load',
    'farm.flor.col.destino': 'Destination',
    'farm.flor.col.volumeCarga': 'Volume',
    'farm.flor.col.dof': 'DOF',
    'farm.flor.statusCarga.expedida': 'Shipped',
    'farm.flor.statusCarga.entregue': 'Delivered',
    'farm.flor.filtro.fase': 'Stage',
    'farm.flor.filtro.status': 'Status',
    'farm.flor.filtro.mes': 'Month',
    'farm.flor.filtro.destino': 'Destination',
    'farm.flor.todos': 'All',
    'farm.flor.todas': 'All',
    'farm.flor.buscaTalhao': 'Search by stand or clone',
    'farm.flor.buscaCarga': 'Search by load, DOF or destination',
    'farm.flor.excel': 'Excel',
    'farm.flor.semResultado': 'Nothing to show with these filters.',
    'farm.flor.semVolume': 'No estimate',
    'farm.flor.ajuda.talhoes': 'Each eucalyptus stand with its clone, age and cutting cycle. The volume comes from the clone mean increment. Crown color and size on the drawing follow the age.',
    'farm.flor.ajuda.fornos': 'The kiln battery in cycle: empty for unloading and loading, carbonizing and cooling until unloading. The chips filter the list.',
    'farm.flor.ajuda.producao': 'Charcoal produced and shipped per month, and the loads that leave with a DOF.',
  },
  es: {
    'farm.flor.proposta': 'Propuesta hasta que Segreda traiga el proceso',
    'farm.flor.kpi.hectares': 'Eucalipto plantado',
    'farm.flor.kpi.prontos': 'Listos para corte',
    'farm.flor.kpi.fornos': 'Hornos activos',
    'farm.flor.kpi.carvao': 'Carbón en {{mes}}',
    'farm.flor.ha': '{{n}} ha',
    'farm.flor.m3': '{{n}} m³',
    'farm.flor.m3Ha': '{{n}} m³/ha',
    'farm.flor.st': '{{n}} st de leña',
    'farm.flor.deTotal': '{{n}} de {{total}}',
    'farm.flor.cliqueNoTalhao': 'Haga clic en un rodal para filtrar la lista',
    'farm.flor.aba.talhoes': 'Rodales',
    'farm.flor.aba.fornos': 'Hornos',
    'farm.flor.aba.producao': 'Producción',
    'farm.flor.abas': 'Partes del módulo',
    'farm.flor.fase.formacao': 'En formación',
    'farm.flor.fase.crescimento': 'En crecimiento',
    'farm.flor.fase.pronto': 'Listo para corte',
    'farm.flor.fase.corte': 'En corte',
    'farm.flor.faseQtd': '{{n}} rodales',
    'farm.flor.col.talhao': 'Rodal',
    'farm.flor.col.clone': 'Clon',
    'farm.flor.col.plantio': 'Plantación',
    'farm.flor.col.ciclo': 'Ciclo de corte',
    'farm.flor.col.volume': 'Volumen estimado',
    'farm.flor.col.fase': 'Fase',
    'farm.flor.rotacao': '{{n}}ª rotación',
    'farm.flor.idadeMeses': '{{n}} meses',
    'farm.flor.idadeAnos': '{{a}} años y {{m}} meses',
    'farm.flor.idadeAnosExatos': '{{a}} años',
    'farm.flor.cortePrevisto': 'Corte previsto en {{data}}',
    'farm.flor.percentCiclo': '{{n}}% del ciclo',
    'farm.flor.bateria': 'Batería {{b}}',
    'farm.flor.forno': 'Horno {{n}}',
    'farm.flor.status.carbonizando': 'Carbonizando',
    'farm.flor.status.resfriando': 'Enfriando',
    'farm.flor.status.vazio': 'Vacío',
    'farm.flor.status.ativos': 'Activos',
    'farm.flor.fornoTooltip': 'Horno {{n}}, {{status}}',
    'farm.flor.col.forno': 'Horno',
    'farm.flor.col.status': 'Estado',
    'farm.flor.col.cicloForno': 'Ciclo',
    'farm.flor.col.descarga': 'Descarga',
    'farm.flor.col.carga': 'Carga del horno',
    'farm.flor.col.origem': 'Origen de la leña',
    'farm.flor.diaDoCiclo': 'Día {{d}} de {{total}}',
    'farm.flor.acesoEm': 'Encendido el {{data}}',
    'farm.flor.aguardandoCarga': 'Esperando carga',
    'farm.flor.grafico.titulo': 'Carbón por mes',
    'farm.flor.grafico.produzido': 'Producido',
    'farm.flor.grafico.expedido': 'Despachado',
    'farm.flor.grafico.vazio': 'Sin producción en el período',
    'farm.flor.grafico.subtitulo': 'Metros cúbicos en los últimos 12 meses',
    'farm.flor.col.cargaCarvao': 'Carga',
    'farm.flor.col.destino': 'Destino',
    'farm.flor.col.volumeCarga': 'Volumen',
    'farm.flor.col.dof': 'DOF',
    'farm.flor.statusCarga.expedida': 'Despachada',
    'farm.flor.statusCarga.entregue': 'Entregada',
    'farm.flor.filtro.fase': 'Fase',
    'farm.flor.filtro.status': 'Estado',
    'farm.flor.filtro.mes': 'Mes',
    'farm.flor.filtro.destino': 'Destino',
    'farm.flor.todos': 'Todos',
    'farm.flor.todas': 'Todas',
    'farm.flor.buscaTalhao': 'Buscar por rodal o clon',
    'farm.flor.buscaCarga': 'Buscar por carga, DOF o destino',
    'farm.flor.excel': 'Excel',
    'farm.flor.semResultado': 'Nada para mostrar con estos filtros.',
    'farm.flor.semVolume': 'Sin estimación',
    'farm.flor.ajuda.talhoes': 'Cada rodal de eucalipto con el clon, la edad y el ciclo de corte. El volumen sale del incremento medio del clon. El color y el porte de las copas en el dibujo siguen la edad.',
    'farm.flor.ajuda.fornos': 'La batería de hornos en ciclo: vacío para descarga y carga, carbonizando y enfriando hasta la descarga. Los chips filtran la lista.',
    'farm.flor.ajuda.producao': 'El carbón producido y despachado por mes, y las cargas que salen con DOF.',
  },
}
